module.exports = new __parcel__URL__("Assassinskill_28.b1678470.png").toString();